<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">Instructor Breakdown</h3>
    </div>
    <div class="panel-body" v-if="!instructorBreakdown || instructorBreakdown.length === 0">
      <p class="text-muted">No instructor data available.</p>
    </div>
    <table v-else class="table table-striped table-hover">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.key" style="cursor: pointer;" @click="sortByColumn(col.key)">
            {{ col.label }}
            <CalculationTooltip v-if="col.tooltip" :text="col.tooltip" />
            <span v-if="sortKey === col.key">
              <i :class="sortAsc ? 'fa fa-sort-asc' : 'fa fa-sort-desc'"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in sortedRows" :key="row.instructor_id">
          <td>{{ row.instructor_name }}</td>
          <td>{{ row.sessions_completed }}</td>
          <td>{{ row.hours_delivered }}</td>
          <td>{{ row.utilization_rate }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CalculationTooltip from './CalculationTooltip.vue';

export default {
  name: 'InstructorBreakdownTable',
  components: { CalculationTooltip },
  props: {
    instructorBreakdown: { type: Array, default: function() { return []; } }
  },
  data: function() {
    return {
      sortKey: 'sessions_completed',
      sortAsc: false
    };
  },
  computed: {
    columns: function() {
      return [
        { key: 'instructor_name', label: 'Instructor', tooltip: null },
        { key: 'sessions_completed', label: 'Sessions', tooltip: 'Count of completed drives for this instructor.' },
        { key: 'hours_delivered', label: 'Hours', tooltip: 'Total session length in hours for this instructor\'s completed drives.' },
        { key: 'utilization_rate', label: 'Utilization', tooltip: 'Instructor\'s completed sessions divided by (completed + available slots).' }
      ];
    },
    sortedRows: function() {
      if (!this.instructorBreakdown) return [];
      var key = this.sortKey;
      var asc = this.sortAsc;
      var rows = this.instructorBreakdown.slice();
      rows.sort(function(a, b) {
        var valA = a[key];
        var valB = b[key];
        if (typeof valA === 'string') {
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();
        }
        if (valA < valB) return asc ? -1 : 1;
        if (valA > valB) return asc ? 1 : -1;
        return 0;
      });
      return rows;
    }
  },
  methods: {
    sortByColumn: function(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    }
  }
};
</script>
